import { reportError } from "./errorHelper";

export const retainFocusInsideDrawer = (event, parentElementRef, stateRef) => {
  if (
    parentElementRef.current &&
    !parentElementRef.current.contains(event.relatedTarget)
  ) {
    if (stateRef) {
      parentElementRef.current?.focus();
    }
  }
};

export const handleTabIndexingBorderAndClicks = (
  event,
  handleActiveTab,
  tabElementRef
) => {
  try {
    const { parentElements, currentElement } = tabElementRef.current;
    if (event?.key === "Escape") {
      if (parentElements[0]) {
        parentElements[0].focus();
        handleActiveTab({
          parentElements: [],
          currentElement: document.activeElement,
        });
      }
    }
    if (event?.key === "Tab") {
      // Set a slight timeout to ensure focus has shifted
      setTimeout(() => {
        // Remove the border from the previously focused element
        if (document.previousActiveElement) {
          document.previousActiveElement.classList.remove("focusElement");
        }
        if (document.activeElement?.getAttribute("tabindex") !== "-1") {
          const reactPopup = document.getElementById("popup-close-button")
          let activeElement = reactPopup ? reactPopup : document.activeElement
          // to check if react portal popup is mounted or not. If yes, then add focus to it
          if(reactPopup) {
            reactPopup.focus()
          }
          // set the currently focused element
          handleActiveTab({
            parentElements,
            currentElement: activeElement,
          });
          // Add a border to the currently focused element
          activeElement.classList.add("focusElement");
          // Store the currently focused element for future reference
          document.previousActiveElement = activeElement;
        }
      }, 0);
    }

    if (event?.key === "Enter") {
      if (currentElement) {
        if (currentElement?.nodeName === "svg") {
          // for svg element, click on the parent element
          currentElement?.parentNode?.click();
        } else if (!currentElement?.classList.contains("shop-header") && !currentElement?.classList.contains("our-impact-header") && !currentElement?.classList.contains("download-ring-size-guide")) {
          currentElement?.click();
        }
        let newArray = parentElements;
        let popppedElement;
          if (
            currentElement.classList.contains("back_icon") ||
            currentElement?.classList.contains("right_arrow") ||
            currentElement?.id === "popup-close-button"
          ) {
            popppedElement = newArray?.pop();
            popppedElement?.focus();
          } else if (
            currentElement?.classList.contains("ipad_close_icon") ||
            currentElement?.classList.contains("search_cross_icon")
          ) {
            newArray[0]?.focus();
            newArray = [];
          } else {
            newArray.push(document.activeElement);
          }
        handleActiveTab({
          parentElements: newArray,
          currentElement: document.activeElement,
        });
      }
    }
  } catch (error) {
    reportError("Error in Tab Indexing function");
    reportError(error);
  }
};
